import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	SxProps,
	Theme,
	Typography,
} from '@mui/material';

interface ConfirmationPopupProps {
	open: boolean;
	title?: string;
	message: string;
	okButtonLabel?: string;
	cancelButtonLabel?: string;
	okButtonStyle?: SxProps<Theme>;
	cancelButtonStyle?: SxProps<Theme>;
	isLoading?: boolean;
	onOk: () => void;
	onCancel: () => void;
}

function ConfirmationPopup({
	open,
	title = 'Confirm action',
	message,
	okButtonLabel = 'OK',
	cancelButtonLabel = 'Cancel',
	okButtonStyle,
	cancelButtonStyle,
	isLoading = false,
	onOk,
	onCancel,
}: ConfirmationPopupProps) {
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			sx={{
				'& .MuiDialog-paper': {
					padding: '8px',
				},
			}}>
			<DialogTitle sx={{ paddingBottom: '12px' }}>{title}</DialogTitle>
			<DialogContent sx={{ paddingX: '24px', paddingBottom: '18px' }}>
				<Typography fontSize="14px">{message}</Typography>
			</DialogContent>
			<DialogActions sx={{ paddingX: '24px', paddingBottom: '16px' }}>
				<Button
					sx={{
						color: '#7C7C7C',
						textTransform: 'none',
						...cancelButtonStyle,
					}}
					disabled={isLoading}
					onClick={onCancel}>
					{cancelButtonLabel}
				</Button>
				<Button
					sx={{
						textTransform: 'none',
						...okButtonStyle,
					}}
					disabled={isLoading}
					onClick={onOk}>
					{isLoading ? 'Loading...' : okButtonLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ConfirmationPopup;
